/**
 * A no-operation function that does nothing.
 * This can be used as a placeholder or default function.
 *
 * @example
 * noop(); // Does nothing
 *
 * @returns {void} This function does not return anything.
 */
export function noop(...args: unknown[]): void;
export function noop(): void {}
